import React from 'react'

export const NoCategories = () => {
    return (
        <tbody>
            <tr>
                <td style={{textAlign: 'center', backgroundColor: '#eee'}}>No categories</td>
            </tr>
        </tbody>
    )
}


// WEBPACK FOOTER //
// ./src/dashboard/categories/NoCategories.js